import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot } from '@angular/router';
import { ClientService } from '../../service/client.service';
import {ClientDetails} from '../models/client.model';
import {Observable} from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ClientResolver implements Resolve<any> {

  constructor(private clientService: ClientService) {}

  resolve(route: ActivatedRouteSnapshot): Observable<ClientDetails> {
    const id = route.paramMap.get('id')!;
    return this.clientService.getClientById(id);
  }
}
